import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {TemplateNode} from "#template/template-node/template-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {S1Variable} from "#template/nodes/variable/s1-variable"

export type HingeRotationParameters = {
    axis: "x" | "y" | "z"
    rotation: S1Variable
}

const hingeRotationDefinition: TemplateNodeDefinition<HingeRotationParameters> = {
    nodeClass: "HingeRotation",
    validation: {
        parameters: z.object({
            axis: z.enum(["x", "y", "z"]),
            rotation: graphNode(S1Variable),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class HingeRotation extends TemplateNode<HingeRotationParameters> {
    public override get definition() {
        return hingeRotationDefinition
    }
}
